import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class HelpHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	// getMachines(queryParams) {
	// 	return new Observable((observer: any) => {
	// 		const path = '/dashboard/get_all_macs';
	// 		const myInit = {
	// 			response: false,
	// 			queryStringParameters: queryParams
	// 		};
	// 		API.get(this.apiName, path, myInit).then(response => {
	// 		  observer.next(response.data);
	// 		}).catch(err => {
	// 			console.log(err.response);
	// 			observer.error(err);
	// 		});
	// 	});
	// }

	getHelpFeedback(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_help_feedback';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getHelpRemarks(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_help_remarks';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}



	saveRemarks(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/save_remarks';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(resp => {
				observer.next(resp);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}


}
